var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.title,"breadcrumbs":_vm.breadcrumbs}}),_c('div',{staticClass:"row"},_vm._l((_vm.settings),function(tag,index){return _c('div',{key:index,staticClass:"col-sm-12 col-md-6 col-xl-4 pb-3"},[_c('single-tag',{attrs:{"tag":tag}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }